import { AuthEndpoint } from '@datarock/api-client';
import Authorized from './Authorized';
import FullscreenLoader from '../../components/FullscreenLoader';
import React from 'react';
import Unauthorized from './Unauthorized';
import { useAuth } from 'oidc-react';

export default function Index() {
  const auth = useAuth();

  const hasUserData = !!auth.userData;
  const isExpired = auth.userData?.expired;
  const isAuthed = hasUserData && !isExpired;
  const isTokenSet = isAuthed && !!AuthEndpoint.accessToken;

  if (auth.isLoading) {
    return <FullscreenLoader withLogo />;
  }

  if (isTokenSet) {
    return <Authorized />;
  }

  return <Unauthorized />;
}
